import { render } from "./SwiperSlide.vue?vue&type=template&id=0d93c3d0"
import script from "./SwiperSlide.vue?vue&type=script&lang=js"
export * from "./SwiperSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/SwiperSlide.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d93c3d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d93c3d0', __exports__)) {
    api.reload('0d93c3d0', __exports__)
  }
  
  module.hot.accept("./SwiperSlide.vue?vue&type=template&id=0d93c3d0", () => {
    api.rerender('0d93c3d0', render)
  })

}


export default __exports__